import { render, staticRenderFns } from "./permit-document-selector.vue?vue&type=template&id=74606371&scoped=true&lang=pug&"
import script from "./permit-document-selector.vue?vue&type=script&lang=ts&"
export * from "./permit-document-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74606371",
  null
  
)

export default component.exports